import { render, staticRenderFns } from "./GroupSessionAttendeeRemovedNotification.vue?vue&type=template&id=fa867608&scoped=true&"
import script from "./GroupSessionAttendeeRemovedNotification.vue?vue&type=script&lang=js&"
export * from "./GroupSessionAttendeeRemovedNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa867608",
  null
  
)

export default component.exports